import { type FC } from 'react'

import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import { Button } from 'components/Button'

interface DialogNoLongerDirectReportProps
  extends Omit<DialogProps, 'children'> {
  name: string
  regionName: string

  onClick: () => void
}

import ImgFence from 'assets/icons/img-fence.svg'

const DialogNoLongerDirectReport: FC<DialogNoLongerDirectReportProps> = ({
  name,
  regionName,
  onClick = () => {},
  ...props
}) => {
  return (
    <Dialog autoFocus={false} {...props}>
      <DialogOverlay />
      <DialogContent className="!rounded-lg">
        <div className="p-6 space-y-2">
          <ImgFence width={120} height={120} />

          <Text variant="display-sm" className="!mt-4">
            {name} sudah konfirmasi bahwa {regionName} tidak lagi menjadi Daerah
            Dinas Pendidikannya
          </Text>

          <Text variant="body-lg" color="subdued">
            Saat ini Anda tidak lagi memiliki akses terhadap Pengelolaan Kinerja
            pegawai. Pastikan data penunjukkan (<em>plotting</em>) Tim Kerja di
            Simtendik sesuai.
          </Text>

          <div className="flex gap-5 !mt-4">
            <Button size="lg" variant="ghost" onClick={onClick}>
              Tutup
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogNoLongerDirectReport
